import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | (() => void);
  className?: string;
  color?: string | "clay";
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({ children, onClick, className = '', color = 'clay', disabled = false, type = 'button' }) => {
  return (
    <button 
      type={type}
      onClick={onClick}
      className={`inline-block bg-muted-${color} bg-opacity-80 text-muted-black py-3 border border-muted-darkGrey px-6 rounded-[10px] shadow-[5px_5px_0_-2px_theme(colors.muted.darkGrey)] hover:bg-opacity-40 hover:text-muted-black hover:shadow-[10px_10px_0_-2px_theme(colors.muted.darkGrey)] transition-all ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} `}
    >
      {children}
    </button>
  );
};

export default Button; 